// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"69207b40","213":"d545d048","238":"57c9b8a3","239":"b67fbdf4","557":"c7a177e1","622":"ca383a6b","904":"62ccc93b"}[chunkId] + ".chunk.js";
};